










import { Component, Vue, Prop } from "vue-property-decorator";
import { TagsViewModule } from "@/store/modules/tags-view";

@Component({
  name: "AppMain",
})
export default class extends Vue {
  [x: string]: any;

  get cachedViews() {
    return TagsViewModule.cachedViews;
  }

  get key() {
    return this.$route.path;
  }
  private handleClose() {}
}
